import { AdminTemplate, IAdminTemplate } from "./admin-template.entity";
import { IPartnerTemplate, PartnerTemplate } from "./partner-template.entity";

type ITemplate = IAdminTemplate | IPartnerTemplate;
export { ITemplate };
export function buildTemplate(data?: Partial<ITemplate>): ITemplate {
  if ((data as IPartnerTemplate)?.partnerId) return new PartnerTemplate(data);
  return new AdminTemplate(data);
}
